import React from 'react';
import { Spin, Typography } from 'antd';
import FordCreditCarCards from '../FordCreditCarCards/FordCreditCarCards';
import { Car } from '../../types/home';

const { Title } = Typography;

interface FordCreditSectionProps {
  loading: boolean;
  error: string | null;
  cars: Array<Car>;
  carsLength: number;
  starToggle: string;
  setStarChanged: (starChanged: boolean) => void;
  setDataSource: (cars: Array<Car>) => void;
  onNavigateToDetails: () => void;
}

const FordCreditSection: React.FC<FordCreditSectionProps> = ({
  loading,
  error,
  cars,
  carsLength,
  starToggle,
  setStarChanged,
  setDataSource,
  onNavigateToDetails
}) => {
  return (
    <div className="car-cards-wrapper">
      <Title level={2} className="section-header">
      Ford Credit
      </Title>
      {loading ? (
        <div className="loading-spinner">
          <Spin tip="Ford Creit Browser..." />
        </div>
      ) : (
        <FordCreditCarCards
          page={1}
          itemsPerPage={6}
          dataSource={cars}
          carsLength={carsLength}
          onPageChange={() => {}}
          setDataSource={setDataSource}
          starToggle={starToggle}
          setStarChanged={setStarChanged}
          onNavigateToDetails={onNavigateToDetails}
          pages={false}
        />
      )}
    </div>
  );
};

export default FordCreditSection;
